import React from 'react'

import { useClaimPageModal } from '../../hooks/useClaimPageModal'
import { ClaimStatusTypes } from '../../models/ClaimStatus.model'

type ClaimPageCardProps = {
  organizationType: 'hospital' | 'agency'
  organizationId: number
  organizationName: string
  initialClaimStatus?: ClaimStatusTypes
  onStatusChange?: (newStatus: ClaimStatusTypes) => void
  entityLabel?: string
}

export const ClaimPageCard: React.FC<ClaimPageCardProps> = ({
  organizationType,
  organizationId,
  organizationName,
  initialClaimStatus,
  onStatusChange,
  entityLabel,
}) => {
  const label = entityLabel ?? (organizationType === 'hospital' ? 'hospital' : 'agency')
  const { openClaimModal, claimModal } = useClaimPageModal({
    initialClaimStatus,
    onStatusChange,
    organizationId,
    organizationName,
    organizationType,
  })

  return (
    <div className="mb-6 rounded-2xl bg-white p-5 shadow-sm ring-1 ring-black/5">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
        <div className="min-w-0">
          <h3 className="text-base font-semibold text-graphite-grey">Represent this {label}?</h3>
          <p className="mt-0.5 text-xs leading-relaxed text-gray-600">
            Claim this page to keep your details accurate and see every review as it comes in.
          </p>
        </div>
        <button
          type="button"
          onClick={openClaimModal}
          className="inline-flex shrink-0 items-center justify-center rounded-full border-2 border-aqua-mint px-5 py-2 text-sm font-semibold text-aqua-mint transition-colors hover:bg-aqua-mint/5"
        >
          Claim page
        </button>
      </div>
      {claimModal}
    </div>
  )
}
